export default __webpack_public_path__ + "static/media/illustration-auth.f39d4a21.png";